import React from 'react';
import PropTypes from 'prop-types';

import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { GameTagsPageContent } from 'components/game-tags-page-content/game-tags-page-content';
import { PAGE_NAMES } from '../../constants';

const GameTags = ({ match: { params: { tag } } }) => (
  <>
    <HeadHelmet
      page={PAGE_NAMES.GAME_TAGS}
      values={{ tag }}
    />

    <GameTagsPageContent tag={tag} coreProps={{ withAi: true }} />
  </>
);

GameTags.propTypes = {
  match: PropTypes.shape().isRequired,
};

export default GameTags;
